import React from 'react';
import { Box, Flex, HStack, Text, IconButton } from '@chakra-ui/react';
import { Handle, Position } from 'reactflow';
import { FiClock, FiEdit, FiCopy, FiTrash2 } from 'react-icons/fi';

const DynamicDelayNode = ({ data }) => {
  const isDynamic = data.delaySubtype === 'dynamic';

  return (
    <Box
      bg="white"
      borderWidth="2px"
      borderColor={data.selected ? 'purple.500' : isDynamic ? '#8B5CF6' : '#a475f9'}
      borderRadius="xl"
      borderStyle={'solid'}
      boxShadow={data.selected ? 'xl' : 'lg'}
      minW="240px"
    >
      <Handle 
        type="target" 
        position={Position.Left} 
        style={{ background: '#a475f9' }} 
      />
      
      <Flex
        bgGradient={isDynamic ? 'linear(to-r, #a475f9, #8B5CF6)' : undefined}
        bg={isDynamic ? undefined : '#a475f9'}
        color="white"
        px={4}
        py={2.5}
        borderTopRadius="xl"
        align="center"
        justify="space-between"
      >
        <HStack spacing={2}>
          <Box position="relative">
            <FiClock />
            {/* {isDynamic && (
              <Box position="absolute" bottom="-2px" right="-2px">
                <FiZap size={10} color="#FBAF3F" />
              </Box>
            )} */}
          </Box>
          <Text noOfLines={1} fontSize="sm" fontWeight="medium">Wait</Text>
        </HStack>
        <HStack spacing={1}>
          {/* {isDynamic && (
            <Tag 
              variant="outline" 
              fontSize="10px" 
            size={"sm"}
              bg="white" 
              color="#8B5CF6" 
              borderColor="#8B5CF6"
            >
              Dynamic
            </Tag>
          )} */}
          <IconButton
            size="xs"
            variant="ghost"
            color={"white"}
            icon={<FiEdit />}
            onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
          />
          <IconButton
            size="xs"
            variant="ghost"
            color={"white"}
            icon={<FiCopy />}
            onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
          />
          <IconButton
            size="xs"
            variant="ghost"
            color={"white"}
            icon={<FiTrash2 />}
            onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
          />
        </HStack>
      </Flex>

      <Box p={3.5}>
        <Text fontSize="sm" fontWeight="medium">
          {data.label || 'Wait'}
        </Text>
        {isDynamic ? (
          <Text fontSize="xs" color="gray.600" mt={1.5}>
            Wait based on {
              data.dynamicWaitSource === 'event' ? 'event data' : 
              data.dynamicWaitSource === 'api' ? 'API response' : 
              'expression'
            }
          </Text>
        ) : data.duration ? (
          <Text fontSize="xs" color="gray.600" mt={1.5}>
            {data.duration} {data.unit || 'days'}
          </Text>
        ) : null}
      </Box>

      <Handle 
        type="source" 
        position={Position.Right} 
        style={{ background: '#a475f9' }} 
      />
    </Box>
  );
};

export default DynamicDelayNode;